import { useState } from "react";

export function useLanding(initial?: string) {
  const [selectedGroup, selectGroup] = useState(initial || "");
  const [selectedTag, selectTag] = useState("");
  const [sorter, setSorter] = useState<"name" | "views" | "bookmarks">("name");
  return {
    selectedGroup,
    selectGroup,
    selectedTag,
    selectTag,
    sorter,
    setSorter,
  };
}
